import { AlertCircle } from 'lucide-react'
import { criticalRowLabel, type CriticalIssueVM } from '../utils/incidentSelectors'

interface CriticalIssuesProps {
  issues: CriticalIssueVM[]
}

export function CriticalIssues({ issues }: CriticalIssuesProps): JSX.Element {
  const now = new Date()
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4">
      <div className="mb-3 flex items-center gap-2">
        <AlertCircle className="h-5 w-5 text-red-500" />
        <h3 className="text-base font-semibold text-gray-900">Critical Issues</h3>
      </div>
      {issues.length === 0 ? (
        <p className="py-6 text-center text-sm text-gray-400">No critical issues.</p>
      ) : (
        <ul className="divide-y divide-gray-100">
          {issues.map((issue) => (
            <li key={issue.id} className="flex items-center justify-between py-2">
              <div>
                <p className="text-sm font-medium text-gray-900">{issue.title}</p>
                <p className="text-xs text-gray-400">{criticalRowLabel(issue, now)}</p>
              </div>
              <span className="rounded bg-red-50 px-2 py-0.5 text-xs font-medium text-red-600">Critical</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
